import {
  type PrometheusMonitorTestEndpointResponse,
  type PrometheusMonitorTestEndpointSuccessResponse
} from 'queries/prometheus/types'

export function isSearchPrometheusMonitorsSuccessResponse(
  response: PrometheusMonitorTestEndpointResponse
): response is PrometheusMonitorTestEndpointSuccessResponse {
  return response !== null && response.error === null
}
